const locale = {
  placeholder: 'Enter IP address',
  errorMsg: {
    INVALID: 'Incorrect IP format. Enter a correct IP. ',
    INVALID_SUBNET: 'IP is not in the subnet IP range. Enter an available IP within the range of {{subnet}}.',
    INVALID_IPV4: 'Incorrect IP format. Enter a correct IP. ',
    // deprecated
    INVALID_IPV6: 'Incorrect IP format. Enter a correct IP. ',
    // deprecated
    IPV4_NOT_IN_SUBNET: 'IP is not in the subnet IP range. Enter an available IP within the range of {{subnet}}.',
    // deprecated
    IPV6_NOT_IN_SUBNET: 'IP is not in the subnet IP range. Enter an available IP within the range of {{subnet}}.',
    // deprecated
    EXCLUDES: 'IP is used. Enter an available IP.',
    EXISTS: 'IP is duplicated. Enter an available IP.'
  },
  recommend: 'Recommended:'
};
export default locale;